import axios from "axios";

export const EMAILWISH_API_TOKEN_KEY = "emailwish_api_token";

export function setEmailwishApiToken(token: string | null | undefined): void {
  if (token) {
    localStorage.setItem(EMAILWISH_API_TOKEN_KEY, token);
  } else {
    localStorage.removeItem(EMAILWISH_API_TOKEN_KEY);
  }
}

export function getEmailwishApiToken(): string | null {
  return localStorage.getItem(EMAILWISH_API_TOKEN_KEY);
}

let interceptorRegistered = false;

export function registerEmailwishApiTokenInterceptor(): void {
  if (interceptorRegistered) {
    return;
  }

  interceptorRegistered = true;

  const backendBase = process.env.REACT_APP_BACKEND_API_URL ?? "";

  axios.interceptors.request.use((config) => {
    const token = getEmailwishApiToken();
    const url = config.url ?? "";

    if (!token || !backendBase || !url.includes(backendBase)) {
      return config;
    }

    config.headers = config.headers ?? {};
    config.headers["X-Emailwish-Api-Token"] = token;

    return config;
  });
}
